module.exports = __webpack_public_path__ + "static/media/808RowLabel--CP.3372ea97.svg";